import { render, staticRenderFns } from "./BottomSheetComponent.vue?vue&type=template&id=b36c5202&"
import script from "./BottomSheetComponent.vue?vue&type=script&lang=js&"
export * from "./BottomSheetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports